import { Typography } from '@material-ui/core'
import React from 'react'
import { Labeled } from 'react-admin'

import { User } from '../../models/user'

interface UserFeatureFlagsProps {
  user: Omit<User, 'featureFlags'> & { feature_flags: User['featureFlags'] }
}

const SPECIAL_FLAGS = ['show-flatbed', 'show-reefer']

export function UserFeatureFlags({ user }: UserFeatureFlagsProps) {
  const flags = user.feature_flags || {}
  const activeFeatureFlags = Object.keys(flags).filter((flag) => flags[flag])
  const specialFlags = activeFeatureFlags.filter((f) => SPECIAL_FLAGS.includes(f))
  const otherFlags = activeFeatureFlags.filter((f) => !SPECIAL_FLAGS.includes(f))

  return (
    <>
      {specialFlags.length ? (
        <>
          <Labeled label="Special Trailer Feature Flags">
            <Typography variant="body2">{specialFlags.join(', ')}</Typography>
          </Labeled>
          <br />
        </>
      ) : null}

      <Labeled label="Feature Flags">
        <Typography variant="body2">{otherFlags.join(', ')}</Typography>
      </Labeled>
    </>
  )
}
